var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShapePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1110,
    height: 1080,
    viewBox: "0 0 1110 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1030.7 711.333L1109.99 665.482V757.185V848.889L1030.7 894.741L951.417 940.593V848.889V757.185L1030.7 711.333ZM317.135 482.074V573.778V665.482V757.185V848.889L237.859 803.037L158.583 757.185V665.482V390.37V298.667L237.859 252.815L475.708 115.259L554.995 69.4074L634.281 23.5556L713.557 -22.2963L634.281 -68.1481L554.995 -114L475.708 -68.1481L79.2865 161.111L0 206.963V298.667V757.185V848.889L79.2865 894.741L475.708 1124V940.593V757.185V665.482V573.778L396.422 527.926L317.135 482.074ZM1030.7 161.111L872.141 69.4074L792.865 115.259L713.578 161.111L634.302 206.963L555.016 252.815L475.729 298.667L396.453 344.519L475.729 390.37L555.016 436.222L634.302 390.37L713.578 344.519L792.865 298.667L872.141 252.815L951.427 298.667V390.37L872.141 436.222L792.865 482.074L713.578 527.926L634.302 573.778V665.482V757.185V940.593V1124L792.865 1032.3V848.889V757.185V665.482L872.141 619.63L951.427 573.778L1030.71 527.926L1110 482.074V390.37V206.963L1030.7 161.111Z",
    fill: "#8f48ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShapePurple);
export default __webpack_public_path__ + "static/media/logo-shape-purple.65f0ad99.svg";
export { ForwardRef as ReactComponent };